export const phoneNumber = '3394211017';
export const email = 'angelaformisano5@gmail.com';
export const social = {
  instagram: 'https://www.instagram.com/fisioterapista_angela/',
  facebook: 'https://www.facebook.com/dott.ssaAngelaFormisano/',
};
export const piva = '09595981219';

export const trattamenti = [
  'Rieducazione Posturale',
  'Fisioterapia Dermatofunzionale',
  'Terapia Strumentale',
  'Recupero Post-Operatorio',
  'Linfodrenaggio',
];

export const contatti = {
  numero: '3394211017',
  indirizzo: 'Via Nicolò Marcello Venuti 69, 80056 Ercolano NA',
  email: 'angelaformisano5@gmail.com',
  orari: 'Lunedì - Venerdì 15:00 - 20:00',
};

export const servizi = [
  {
    title: 'Rieducazione Posturale',
    dsc: 'Percorso mirato a migliorare postura, mobilità e allineamento del corpo, riducendo rigidità e dolori.',
    id: 1,
    img: '/images/rieducazione-posturale.webp',
  },
  {
    title: 'Fisioterapia Dermatofunzionale',
    dsc: 'Trattamenti specifici per migliorare tono tissutale, cicatrici, edemi e la qualità della pelle.',
    id: 2,
    img: '/images/fisioterapia-dermatofunzionale.webp',
  },
  {
    title: 'Terapia Strumentale',
    dsc: 'Utilizzo di tecnologie terapeutiche per diminuire dolore, ridurre infiammazione e accelerare i tempi di recupero.',
    id: 3,
    img: '/images/terapia-strumentale.webp',
  },
  {
    title: 'Recupero Post-Operatorio',
    dsc: 'Riabilitazione mirata a recuperare forza, mobilità e funzionalità in modo sicuro dopo un intervento chirurgico.',
    id: 4,
    img: '/images/recupero-post-operatorio.webp',
  },
  {
    title: 'Linfodrenaggio',
    dsc: 'Trattamento delicato che favorisce il drenaggio dei liquidi, riduce gonfiore e migliora la circolazione linfatica.',
    id: 5,
    img: '/images/linfodrenaggio.webp',
  },
];

export const accordionItems = [
  {
    question: 'A cosa serve la Fisioterapia?',
    answer:
      "La Fisioterapia è una professione sanitaria che si occupa di prevenzione, cura e riabilitazione dei pazienti che presentano disfunzioni e disturbi legati ai diversi organi e apparati del corpo, come il sistema muscolare, scheletrico, neurologico, cardiaco. L'obiettivo principale della fisioterapia è recuperare e mantenere la massima funzionalità, autonomia e qualità di vita del paziente.",
  },
  {
    question: 'Quando è necessario rivolgersi ad un fisioterapista?',
    answer:
      'È consigliato rivolgersi al fisioterapista in caso di dolori articolari o muscolari ricorrenti, rigidità, limitazioni nei movimenti, traumi, infiammazioni o quando un fastidio persiste da più di qualche giorno senza miglioramenti.',
  },
  {
    question: 'Serve la prescrizione medica per iniziare un trattamento?',
    answer:
      'No, non è necessaria. Puoi iniziare un trattamento fisioterapico anche senza ricetta, ma eventuali esami o diagnosi mediche possono aiutare a definire un percorso più preciso.',
  },
];

export const reviews = [
  {
    id: 1,
    autore: 'Angela C.',
    recensione:
      'Persona dolce e professionale, la consiglio vivamente mi ha risolto un mal di schiena che mi debilitava da molto tempo.',
    stelle: 5,
    link: 'https://www.facebook.com/angelacalifano1958/posts/pfbid0NdXCEMd6RGbHpSbGwqB8r9zu3kPtzUpVgLjztssg4E1QHjJzRZKxZHdhjHuoyHJxl  ',
  },
  {
    id: 2,
    autore: 'Maurizio B.',
    recensione:
      'Soffrivo la cervicale da molto tempo, dopo aver conosciuto la dott.ssa Angela Formisano ho recuperato moltissimo, bravissima nel fare il suo lavoro, molto professionale, gentilissima e disponibile.',
    stelle: 5,
    link: 'https://www.facebook.com/maurizio.blando.9/posts/pfbid0PkHPfmpYnUzeyfGxwZNMRZgVJ3aQb6v2fYbRHaheTzfFHMJputckfwJa5SePHQVnl',
  },
  {
    id: 3,
    autore: 'Letizia P.',
    recensione:
      'La dottoressa è preparata, professionale, disponibile, dolcissima e paziente. Mi ha seguito e curato meticolosamente rimettendomi in forma, grazie ancora sei un angelo',
    stelle: 5,
    link: 'https://www.facebook.com/letizia.pirrottina/posts/pfbid02qBAVYLyd9Do6owYxzou7RB3Z4bnYgh9Mz3r1xdEuW3KhUev35M6gvPnCXfoAZcBul',
  },
  {
    id: 5,
    autore: 'Lino D.',
    recensione:
      "La Dott.ssa Angela è una persona molto professionale, mi sono affidato a lei per un problema che ho avuto alle mie ginocchia (artrosi precoce) ed è riuscita dalla prima seduta a dare sollievo nella zona da me rilevata dolorosa, non potevo fare scelta migliore. Oltre ad essere molto competente nel suo lavoro e anche una ragazza umile, gentile e molto umana, dà pieno valore all'ascolto del paziente. La consiglio vivamente!",
    stelle: 5,
    link: 'https://www.facebook.com/lino.desanti/posts/pfbid0eBAEfaiR3GdypKPSPqc4ymyqahSPa8ehgKzSBfuq7d4zgbx4oACueB1AQ4BkT38Cl',
  },
];

export const studi = [
  'Laurea triennale in Fisioterapia',
  'Master in Posturologia',
  'Laurea magistrale in Fisioterapia',
];

export const specializzazioni = [
  'Rieducazione Posturale',
  'Fisioterapia dermatofunzionale',
  'Patologie del sistema muscoloscheletrico',
];

export const timelineItems = [
  {
    title:
      "Laurea triennale in Fisioterapia presso l'Università Federico II di Napoli",
    year: '2019',
  },
  {
    title: "Master in Posturologia presso l'Università telematica Pegaso",
    year: '2022',
  },
  {
    title:
      'Laurea Magistrale in Scienze riabilitative delle professioni sanitarie',
    year: '2024',
  },
  {
    title: 'Formazione',
    year: 'In corso',
  },
];

export const therapies = {
  recuperoPostOperatorio: {
    faq: [
      // {
      //   question: 'La laserterapia fa male? Ci sono effetti collaterali?',
      //   answer:
      //     'No, la laserterapia non fa male, è un trattamento non invasivo e generalmente ben tollerato. Durante la seduta puoi avvertire solo una leggera sensazione di calore, che è del tutto normale. <br/> Gli effetti collaterali sono rari, in alcuni casi può comparire un lieve arrossamento temporaneo della zona trattata, che tende a scomparire in breve tempo.<br/>La laserterapia non comporta rischi significativi se eseguita da un professionista qualificato e seguendo le corrette precauzioni.',
      // },
    ],
    title:
      'Riabilitazione Post-Operatoria ad Ercolano:<br/>il percorso mirato per recuperare mobilità e ridurre il dolore',
    subtitle:
      'Un trattamento personalizzato per favorire la guarigione e tornare rapidamente alla piena funzionalità.',
    dsc: "Dopo un'operazione chirurgica, a prescindere dalla gravità dell'intervento, l'obiettivo principale è recuperare la piena funzionalità del corpo.<br/>La fisioterapia è fondamentale in questi casi per ristabilire la corretta funzione della zona operata, prevenendo rigidità e dolori. Con un approccio globale e personalizzato, attraverso tecniche di terapia manuale, strumentale e di riequilibrio posturale, si velocizza il recupero funzionale migliorando mobilità, elasticità e forza muscolare.",
    img: '/images/terapia.webp',
  },
  rieducazionePosturale: {
    pathologies: {
      title: 'Soluzioni efficaci per ogni patologia',
      subtitle: 'Cosa Curo',
      dsc: "La rieducazione posturale aiuta a migliorare l'allineamento del corpo, ridurre le tensioni e prevenire dolori legati a posture scorrette. È indicata per molte problematiche muscolo-scheletriche e permette di recuperare equilibrio e mobilità in modo efficace.",
      list: [
        'Lombalgia / Lombosciatalgia',
        'Ernie',
        'Protrusioni',
        'Artrosi',
        'Cervicalgia / Cervicobrachialgia',
        'Epicondilite / Epitrocleite',
        'Sindrome della spalla congelata',
        'Scoliosi / Dorso curvo',
        'Recupero post-operatorio',
      ],
    },
    faq: [],
    title: 'Pancafit®: Il Riequilibrio Posturale Globale per la tua Salute',
    dsc: "Il Metodo Raggi® è una metodica innovativa nel campo della rieducazione posturale, poiché non si limita a trattare il sintomo, ma cerca la causa profonda dei tuoi disturbi.<br/>Il trattamento di riequilibrio posturale avviene utilizzando Pancafit®, uno strumento unico che ci permette di eseguire un Allungamento Muscolare Globale Decompensato.  Cosa significa? Significa lavorare con posture che aiutano il tuo corpo a ritrovare benessere e equilibrio generale. Questo permette di allungare contemporaneamente e in modo mirato tutte le catene neuromiofasciali che con il tempo si sono retratte, irrigidite, a causa di vecchi traumi, dolori cronici, posture prolungate scorrette, attivando allo stesso tempo il muscolo diaframma, centro del nostro respiro.<br/>Dopo un'attenta e approfondita valutazione posturale, tenendo conto della storia clinica, delle abitudini e della morfologia specifica della persona, si elabora un intervento riabilitativo individuale per aiutare a ritrovare il proprio benessere e migliorare di conseguenza la propria qualità di vita.<br/>Questo trattamento riabilitativo è indicato per persone di tutte le età e può essere applicato sia in forma preventiva, per ritrovare l'armonia delle forme del tuo corpo, sia come forma di cura per dolori muscolari o rigidità articolari.",
    img: '/images/terapia.webp',
  },
  fisioterapiaDermatofunzionale: {
    pathologies: {
      title: 'Soluzioni efficaci per ogni patologia',
      subtitle: 'Cosa Curo',
      dsc: 'Con la fisioterapia dermatofunzionale tratteremo',
      list: [
        {
          title: 'Cicatrici post-chirurgiche / post-traumatiche',
          dsc: "Prevenendo problemi posturali e retrazioni dei tessuti, migliorandone di conseguenza l'aspetto estetico",
        },
        {
          title:
            'Dopo quante sedute di fisioterapia dermatofunzionale noterò risultati?',
          dsc: "Già dalle prime sedute noterai cambiamenti sia estetici, come la riduzione rughe del viso o il miglioramento dell'aspetto a buccia d'arancia della pelle, che funzionali, come una diminuzione del dolore nel caso di gambe pesanti o cellulite.",
        },
        {
          title:
            'Cellulite, riconosciuta come pannicolopatia edematofibrosclerotica (PEFS)',
          dsc: "Agendo sulle alterazioni del microcircolo e del tessuto adiposo, migliorando non solo il drenaggio dei liquidi in eccesso ma anche l'aspetto estetico della cute, riducendo la classica “buccia d'arancia” visibile sulle gambe",
        },
        {
          title: 'Adiposità localizzata',
          dsc: 'Lavorando sulla stimolazione della produzione di collagene ed elastina e sul miglioramento della tonicità muscolare, quasi sempre associata a un accumulo di grasso',
        },
        {
          title: 'Invecchiamento cutaneo',
          dsc: 'Per contrastare e rallentare i segni del tempo sul viso, stimolando la produzione di collagene e riducendo la lassità dei tessuti',
        },
      ],
    },
    faq: [
      {
        question: "Cos'è la fisioterapia dermatofunzionale?",
        answer:
          "La fisioterapia dermatofunzionale è una branca della fisioterapia che si occupa patologie e alterazioni della pelle e dei tessuti sottocunatei (come il grasso). Vengono trattate le alterazioni della cute non solo come inestetismi, ma come vere e proprie disfunzioni dei tessuti che richiedono un intervento terapeutico mirato, come la cellulite e l'invecchiamento cutaneo.",
      },
      {
        question:
          'Come si svolge un trattamento di fisioterapia dermatofunzionale?',
        answer:
          "Il primo incontro prevede sempre una valutazione personalizzata, cui seguirà il trattamento fisioterapico che potrà essere una combinazione di terapia manuale, strumentale e di esercizi mirati a ridurre l'inestetismo indesiderato.",
      },
      {
        question:
          'Quanto dura un trattamento di fisioterapia dermatofunzionale?',
        answer: "Circa un'ora.",
      },
      {
        question: 'Quanto dura un trattamento di linfodrenaggio manuale?',
        answer: "Circa un'ora.",
      },
      {
        question: 'Il drenaggio linfatico manuale è doloroso?',
        answer:
          'Il drenaggio linfatico manuale non è doloroso, è un massaggio superficiale che utilizza manovre lente e delicate, che in nessun caso devono far provare dolore al paziente.',
      },
    ],
    title: 'Fisioterapia Dermatofunzionale: la cura che va oltre la superficie',
    subtitle:
      'Soffri di dolori muscolari, infiammazioni o rigidità articolare?',
    dsc: "La Fisioterapia Dermatofunzionale è una branca della fisioterapia che si concentra sulla valutazione e sul trattamento delle alterazioni che coinvolgono la pelle e i tessuti sottostanti.<br/>Non si limita ad affrontare problemi puramente estetici, ma si dedica al recupero della funzionalità cutanea e tessutale compromessa da patologie, traumi, interventi chirurgici o processi degenerativi. <br/>Questa disciplina unisce una profonda conoscenza dell'anatomia, della fisiologia e della patologia dei tessuti con l'utilizzo di specifiche tecniche manuali e strumentali. L'obiettivo primario è ripristinare l'equilibrio biologico e biomeccanico dei tessuti, migliorando l'elasticità, la vascolarizzazione, il drenaggio e, di conseguenza, la salute e l'aspetto della zona trattata.",
    img: '/images/terapia.webp',
  },
  linfodrenaggio: {
    pathologies: {
      title: 'Soluzioni efficaci per ogni patologia',
      subtitle: 'Cosa Curo',
      dsc: "Attraverso movimenti precisi, lenti e delicati, il DLM è un ottimo alleato per contrastare l'accumulo di liquidi in eccesso, spesso ristagnanti all’interno dei tessuti, migliorando allo stesso tempo l'azione del sistema immunitario.",
      list: [
        'Cellulite',
        'Linfedema',
        'Lipedema',
        'Insufficienza venosa',
        'Edema al viso',
        'Edemi post-operatori',
        'Patologie reumatiche',
        'Patologie ortopediche',
      ],
    },
    faq: [
      // {
      //   question: 'La laserterapia fa male? Ci sono effetti collaterali?',
      //   answer:
      //     'No, la laserterapia non fa male, è un trattamento non invasivo e generalmente ben tollerato. Durante la seduta puoi avvertire solo una leggera sensazione di calore, che è del tutto normale. <br/> Gli effetti collaterali sono rari, in alcuni casi può comparire un lieve arrossamento temporaneo della zona trattata, che tende a scomparire in breve tempo.<br/>La laserterapia non comporta rischi significativi se eseguita da un professionista qualificato e seguendo le corrette precauzioni.',
      // },
    ],
    title:
      'Il Drenaggio Linfatico Manuale (DLM):<br/>un trattamento delicato ma efficiente',
    subtitle: '',
    dsc: "Il Drenaggio Linfatico Manuale (DLM) è un particolare tipo di massaggio che agisce sul sistema linfatico, la rete di vasi e linfonodi responsabile della raccolta dei liquidi in eccesso, delle scorie e delle tossine dai tessuti.<br/>L'obiettivo è stimolare il flusso della linfa quando è bloccato o rallentato, aiutandola a defluire correttamente. Questo riduce il gonfiore e supporta il sistema immunitario.<br/>Attraverso movimenti precisi, lenti e delicati, il DLM è un ottimo alleato per contrastare l’accumulo di liquidi in eccesso, spesso ristagnanti all’interno dei tessuti, migliorando allo stesso tempo l’azione del sistema immunitario.<br/>Il DLM è valido per molteplici condizioni, tra cui:",
    img: '/images/terapia.webp',
  },
  terapiaStrumentale: {
    pathologies: {
      title: 'Soluzioni efficaci per ogni patologia',
      subtitle: 'Cosa Curo',
      dsc: "Le terapie fisiche come la Tecarterapia, l'Ultrasuonoterapia, la Laserterapia e l'Elettrostimolazione sono comunemente impiegate in fisioterapia e riabilitazione per trattare un'ampia gamma di patologie, principalmente a carico dell'apparato muscolo-scheletrico.",
      list: [
        'Dolori Muscolari',
        'Lombalgia / Lombosciatalgia',
        'Patologie Tendinee',
        'Artrosi',
        'Cervicalgia / Cervicobrachialgia',
        'Traumi Acuti',
        'Cellulite',
        'Edemi ed Ematomi',
        'Grasso Localizzato',
      ],
    },
    faq: [
      {
        question: 'Quando è indicata la Terapia Strumentale?',
        answer:
          'In caso di dolori muscolari, contratture, edemi o ematomi, traumi distorsivi, contusioni, artrosi o artrite.',
      },
      {
        question: 'Quanto dura una seduta?',
        answer: 'Una seduta di terapia strumentale dura i 15 e i 30 minuti.',
      },
      {
        question: 'Ci sono controindicazioni?',
        answer:
          'In presenza di alcune condizioni particolari o patologie specifiche è bene astenersi dal sottoporsi a sedute di terapia strumentale.',
      },
    ],
    therapies: {
      title: 'Le Mie Tecnologie',
      dsc: 'Utilizzo macchinari di ultima generazione per garantire la massima efficacia terapeutica. Ecco nel dettaglio le terapie che offro presso il mio studio di Ercolano.',
      cards: [
        {
          title: 'Laserterapia',
          dsc: "La laserterapia sfrutta l'energia della luce per stimolare la rigenerazione cellulare, riducendo dolore e infiammazione, migliorando anche la circolazione sanguigna.",
          img: '/images/terapia-laserterapia.webp',
        },
        {
          title: 'Ultrasuono',
          dsc: "L'ultrasuono è un'onda sonora che penetra nei tessuti ideale per trattare patologie come tendiniti, borsiti e contratture muscolari, accelerando la guarigione dei tessuti.",
          img: '/images/terapia-ultrasuono.webp',
        },
        {
          title: 'Tecarterapia',
          dsc: 'La tecarterapia è una terapia fisica che utilizza correnti elettromagnetiche per stimolare la rigenerazione dei tessuti e ridurre infiammazione, lavorando anche sul miglioramento del drenaggio linfatico, riducendo edemi e gonfiori.',
          img: '/images/terapia-tecarterapia.webp',
        },
        {
          title: 'Elettrostimolazione',
          dsc: "L'elettrostimolazione utilizza impulsi elettrici per stimolare l'attività muscolare e per la gestione del dolore acuto o cronico.",
          img: '/images/terapia-elettrostimolazione.webp',
        },
      ],
    },
    title: 'Terapia strumentale ad Ercolano',
    subtitle:
      'Riduci il dolore ed accelera il recupero grazie alle tecnologie elettromedicali',
    dsc: "Se soffri di dolori muscoloscheletrici o hai subito traumi recenti, la terapia strumentale può essere un valido strumento da inserire nel tuo recupero verso il benessere.<br/>Attraverso l'utilizzo di energie fisiche specifiche, si va ad agire direttamente sul problema migliorandone la condizione, stimolando la rigenerazione tissutale, riducendo gonfiori e liquidi in eccesso, e favorendo una più rapida guarigione.",
    img: '/images/terapia.webp',
  },
};

export const policies = {
  privacy: 'https://www.iubenda.com/privacy-policy/78633533',
  cookies: 'https://www.iubenda.com/privacy-policy/78633533/cookie-policy',
};
